import React from 'react'

export default ({ children }) => (
  <div style={{ margin: '0 auto' }}>
    {children}
  </div>
)
